import { DecoratorNode } from 'lexical';

// SoundCloud URL pattern
const SOUNDCLOUD_REGEX = /^https?:\/\/(www\.)?soundcloud\.com\/[\w-]+\/[\w-]+/i;

export function isSoundCloudUrl(url) {
  return SOUNDCLOUD_REGEX.test(url);
}

export function getSoundCloudEmbedUrl(trackUrl) {
  return `https://w.soundcloud.com/player/?url=${encodeURIComponent(trackUrl)}&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=false`;
}

export class SoundCloudEmbedNode extends DecoratorNode {
  __trackUrl;

  static getType() {
    return 'soundcloud-embed';
  }

  static clone(node) {
    return new SoundCloudEmbedNode(node.__trackUrl, node.__key);
  }

  constructor(trackUrl, key) {
    super(key);
    this.__trackUrl = trackUrl;
  }

  createDOM() {
    const container = document.createElement('div');
    container.className = 'editor-soundcloud-container';

    const embedDiv = document.createElement('div');
    embedDiv.className = 'editor-soundcloud-embed';
    embedDiv.setAttribute('data-lexical-soundcloud', this.__trackUrl);

    const iframe = document.createElement('iframe');
    iframe.src = getSoundCloudEmbedUrl(this.__trackUrl);
    iframe.frameBorder = '0';
    iframe.allow = 'autoplay';
    iframe.title = 'SoundCloud track';

    embedDiv.appendChild(iframe);
    container.appendChild(embedDiv);

    return container;
  }

  updateDOM(prevNode, dom) {
    // Only update if trackUrl changed
    if (prevNode.__trackUrl !== this.__trackUrl) {
      const iframe = dom.querySelector('iframe');
      if (iframe) {
        iframe.src = getSoundCloudEmbedUrl(this.__trackUrl);
      }
    }
    return false;
  }

  decorate() {
    return null;
  }

  exportDOM() {
    const container = document.createElement('div');
    container.className = 'video-embed soundcloud-embed';

    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', getSoundCloudEmbedUrl(this.__trackUrl));
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'autoplay');
    iframe.setAttribute('title', 'SoundCloud track');
    iframe.setAttribute('data-soundcloud-url', this.__trackUrl);

    container.appendChild(iframe);

    return { element: container };
  }

  static importDOM() {
    return {
      div: (node) => {
        if (!node.classList.contains('soundcloud-embed')) {
          return null;
        }
        return {
          conversion: (domNode) => {
            const iframe = domNode.querySelector('iframe');
            if (iframe) {
              const trackUrl = iframe.getAttribute('data-soundcloud-url');
              if (trackUrl) {
                return { node: new SoundCloudEmbedNode(trackUrl) };
              }
            }
            return null;
          },
          priority: 1,
        };
      },
    };
  }

  exportJSON() {
    return {
      type: 'soundcloud-embed',
      version: 1,
      trackUrl: this.__trackUrl,
    };
  }

  static importJSON(json) {
    return new SoundCloudEmbedNode(json.trackUrl);
  }

  getTrackUrl() {
    return this.__trackUrl;
  }

  isInline() {
    return false;
  }

  isIsolated() {
    return true;
  }

  isKeyboardSelectable() {
    return true;
  }
}

export function $createSoundCloudEmbedNode(trackUrl) {
  return new SoundCloudEmbedNode(trackUrl);
}

export function $isSoundCloudEmbedNode(node) {
  return node instanceof SoundCloudEmbedNode;
}
